import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "chips", "inputs"]
  static values = { single: Boolean }

  add() {
    const select = this.selectTarget
    const id = select.value
    const name = select.options[select.selectedIndex].text

    if (!id) return

    if (this.singleValue) {
      // Single-select group (one tag per dropdown). Replace any existing
      // chip/input in this scope and leave the dropdown showing the new
      // option — resetting to placeholder would look like the click had
      // no effect.
      this.chipsTarget.innerHTML = ""
      this.inputsTarget.innerHTML = ""
      this.inputsTarget.appendChild(this.buildInput(id))
      return
    }

    if (this.element.querySelector(`input[value="${id}"]`)) return

    const chip = document.createElement("span")
    chip.className = "inline-flex items-center gap-1 rounded-full bg-warm-100 px-2.5 py-1 text-xs font-medium text-warm-800"
    chip.dataset.tagId = id
    chip.innerHTML = `
      ${name}
      <button type="button" data-action="click->tag-select#remove" data-tag-id="${id}" class="hover:text-red-500 transition-colors">
        <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    `

    this.chipsTarget.appendChild(chip)
    this.inputsTarget.appendChild(this.buildInput(id))
    select.value = ""
  }

  remove(event) {
    const id = event.currentTarget.dataset.tagId
    this.element.querySelector(`span[data-tag-id="${id}"]`)?.remove()
    this.element.querySelector(`input[data-tag-id="${id}"]`)?.remove()
  }

  buildInput(id) {
    const hidden = document.createElement("input")
    hidden.type = "hidden"
    hidden.name = "recipe[tag_ids][]"
    hidden.value = id
    hidden.dataset.tagId = id
    return hidden
  }
}
